import InstallAppModal from "./install-app-modal.component";

export default InstallAppModal;
